<template>
  <div class="battle-main">
    <div :class="['battle-content', battleType === 1 ? '' : 'union']">
      <div v-if="mode === 'edit' || !isShowEnemy" :class="['left']">
        <div class="title">当前上场人员{{ ourSortData.length }}人</div>
        <div class="inner-content">
          <draggable
            v-if="ourSortData && ourSortData.length"
            v-model="ourSortData"
            class="drag-list"
            :disabled="mode === 'view'"
            @change="handleOurSortData"
          >
            <template v-for="(item, index) in ourSortData">
              <div :key="item.uniqueKey" class="item" @click="handleEditRole(item, index)">
                <div class="index">
                  {{ index + 1 }}
                </div>
                <div :class="['icon', getItemBg(item)]">
                  <img :src="item.cover_url" alt="" />
                </div>
                <div class="infos">
                  <p v-if="item.type === 'role'" class="name">
                    {{ item.currentSkin ? item.currentSkin.name : item.name }}
                  </p>
                  <p v-else class="name">{{ item.name }}</p>
                  <!-- <p v-if="item.type === 'role'" class="des">{{ item.name }}</p> -->
                </div>
                <div class="pic">
                  <template v-if="item.type === 'role'">
                    <img
                      v-if="
                        item.actionType === 'skills' &&
                          (item.currentPotentialImage || (item.currentStrengthen && item.currentStrengthen.image))
                      "
                      :src="item.currentPotentialImage || item.currentStrengthen.image"
                      alt=""
                    />
                    <img v-if="item.actionType === 'damage' && item.damage_type" :src="item.damage_type" alt="" />
                    <img
                      v-if="item.actionType === 'repel' && item.currentSkin && item.currentSkin.repel"
                      :src="item.currentSkin.repel"
                      alt=""
                    />
                    <img v-if="item.actionType === 'dead'" src="@/assets/zs_imgs/battle/battle_dead.webp" alt="" />
                  </template>
                  <template v-else>
                    <img v-if="item.actionType === 'skills' && item.skill_image" :src="item.skill_image" alt="" />
                    <img v-if="item.actionType === 'damage' && item.damage_type" :src="item.damage_type" alt="" />
                    <img v-if="item.actionType === 'repel' && item.repel" :src="item.repel" alt="" />
                    <img v-if="item.actionType === 'dead'" src="@/assets/zs_imgs/battle/battle_dead.webp" alt="" />
                  </template>
                </div>
              </div>
            </template>
          </draggable>
          <div v-if="mode === 'edit' && (!ourSortData || !ourSortData.length)" class="add-role" @click="handleAddRole">
            新增角色
          </div>
        </div>
      </div>
      <div :class="['right']">
        <div :class="['container']">
          <div :class="['draggle-box', { 'no-padding': mode === 'view' && !isShowEnemy }]">
            <div
              :style="{
                width: calcSideStyle.width + 'px'
              }"
              class="side left-side"
            >
              <div v-if="mode === 'edit'" class="title">我方阵容</div>
              <draggable
                v-model="ourPositionData"
                :disabled="mode === 'view'"
                :handle="'.drag-item'"
                :forceFallback="true"
                :move="handleOurMove"
                @start="handleOurStart"
                @end="handleOurEnd"
                :class="['drag-list']"
              >
                <div
                  v-for="(item, index) in ourPositionData"
                  :key="index"
                  :style="{
                    width: calcCardStyle.width + 'px',
                    height: calcCardStyle.height + 'px'
                  }"
                  :class="[
                    'drag-bg',
                    { 'union-drag': battleType === 2 },
                    item.type === 0 ? 'no-card' : 'choosed-item',
                    destIndex === index ? 'chosen-item' : ''
                  ]"
                  @click="handleRoleInfo(item)"
                >
                  <div class="drag-item">
                    <template v-if="item.type !== 0">
                      <div v-if="getItemBg(item)" :class="['item-bg']">
                        <div
                          :class="[getItemBg(item), item.actionType === 'skills' ? `${getItemBg(item)}-shadow` : '']"
                        ></div>
                      </div>

                      <div class="item-infos">
                        <img class="role-img" :src="item.cover_url" alt="" />
                        <div class="index">{{ getCurrentIndex(item) }}</div>
                        <div v-if="item.attr_icon" class="attr-icon">
                          <img :src="item.attr_icon" alt="" />
                        </div>
                        <div v-if="item.star && parseInt(item.star) >= 3" class="star-icon">
                          <img :src="getStarUrl(item.star)" alt="" />
                        </div>
                        <div v-if="item.type === 'role'" class="corner-icon">
                          <img :src="getCornerUrl(item)" alt="" />
                        </div>
                        <div
                          v-if="
                            item.currentStrengthen &&
                              item.currentStrengthen.name &&
                              strengthArr.includes(item.currentStrengthen.name)
                          "
                          class="strenth-icon"
                        >
                          <img :src="getStrenthUrl(item.currentStrengthen.name)" alt="" />
                        </div>
                        <div class="bottom-info">
                          <template v-if="item.type === 'role'">
                            <img
                              v-if="
                                item.actionType === 'skills' &&
                                  (item.currentPotentialImage ||
                                    (item.currentStrengthen && item.currentStrengthen.image))
                              "
                              :src="item.currentPotentialImage || item.currentStrengthen.image"
                              alt=""
                            />
                            <img
                              v-if="item.actionType === 'damage' && item.currentSkin && item.damage_type"
                              :src="item.damage_type"
                              alt=""
                            />
                            <img
                              v-if="item.actionType === 'repel' && item.currentSkin && item.currentSkin.repel"
                              :src="item.currentSkin.repel"
                              alt=""
                            />
                            <img
                              v-if="item.actionType === 'dead'"
                              src="@/assets/zs_imgs/battle/battle_dead.webp"
                              alt=""
                            />
                          </template>
                          <template v-else>
                            <img
                              v-if="item.actionType === 'skills' && item.skill_image"
                              :src="item.skill_image"
                              alt=""
                            />
                            <img
                              v-if="item.actionType === 'damage' && item.damage_type"
                              :src="item.damage_type"
                              alt=""
                            />
                            <img v-if="item.actionType === 'repel' && item.repel" :src="item.repel" alt="" />
                            <img
                              v-if="item.actionType === 'dead'"
                              src="@/assets/zs_imgs/battle/battle_dead.webp"
                              alt=""
                            />
                          </template>
                          <span v-if="item.type === 'role'" class="label">
                            {{
                              item.actionType === "skills"
                                ? item.currentSkin
                                  ? item.currentSkin.name
                                  : item.name
                                : actionObj[item.actionType]
                            }}
                          </span>
                          <span v-else class="label">
                            {{
                              item.actionType === "skills"
                                ? item.skill_name
                                  ? item.skill_name
                                  : item.name
                                : actionObj[item.actionType]
                            }}
                          </span>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </draggable>
              <!-- 工会模式 -->
              <div v-if="battleType === 2" class="union-line" @click="handleEditUnion">
                <div class="icon">
                  <img v-if="unionSetting.actionType === 'dead'" src="@/assets/zs_imgs/battle/union_dead.webp" alt="" />
                  <img v-else src="@/assets/zs_imgs/battle/union_battle.webp" alt="" />
                </div>
                <div v-if="unionSetting.actionType === 'dead'" class="dead-content">
                  兰斯洛特行动 - 待命
                </div>
                <div v-else class="action-content">
                  <div class="infos">
                    <div class="name">兰斯洛特行动 - {{ unionSetting.skill }}</div>
                    <div class="des">
                      {{ currentDesc }}
                    </div>
                  </div>
                  <div v-if="currentSkillUrl" class="skill-img">
                    <img :src="currentSkillUrl" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div :class="['arrow', { 'no-padding': mode === 'view', 'no-margin': mode === 'view' && !isShowEnemy }]">
              <img src="@/assets/zs_imgs/battle/battle_arrow.png" alt="" />
            </div>
            <div
              v-if="mode === 'edit' || isShowEnemy"
              :style="{
                width: calcSideStyle.width + 'px'
              }"
              class="side right-side"
            >
              <div v-if="mode === 'edit'" class="title">
                <span>敌方阵容</span>
                <div v-if="mode === 'edit'" class="options">
                  <span style="margin-right: 12px">是否展示敌方阵容</span>
                  <el-switch
                    active-color="#967A5F"
                    inactive-color="#A09D98"
                    :value="isShowEnemy"
                    @change="handleChangeShow"
                  />
                </div>
              </div>
              <div :class="['drag-list']">
                <div
                  v-for="(item, index) in enemyData"
                  :key="index"
                  :style="{
                    width: calcCardStyle.width + 'px',
                    height: calcCardStyle.height + 'px'
                  }"
                  :class="['drag-bg', { 'union-drag': battleType === 2 }]"
                  @click="handleEnemy(index)"
                >
                  <div :class="['enemy-item', item.type === 0 ? '' : 'has-enemy']"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :class="['footer', { 'center-footer': mode === 'view' }]">
      <div class="sp-line">
        <template>
          <span class="tip">本回合SP消耗：</span>
          <span :class="['tip', { 'error-sp': usedSp > lastSp }]"> {{ usedSp }} / {{ lastSp }} </span>
        </template>

        <div class="sp-container">
          <div v-for="item in spCalcData" :key="item.index" class="star-item">
            <img v-if="item.type === 'error'" src="@/assets/zs_imgs/battle/error_star.png" alt="" />
            <img v-else-if="item.type === 'used'" src="@/assets/zs_imgs/battle/used_star.png" alt="" />
            <img v-else-if="item.type === 'round'" src="@/assets/zs_imgs/battle/round_star.png" alt="" />
            <img v-else src="@/assets/zs_imgs/battle/default_star.png" alt="" />

            <span v-if="mode === 'edit'">{{ item.index }}</span>
          </div>
        </div>
      </div>
      <div v-if="mode === 'edit'" class="sp-setting">
        <el-popover
          width="202"
          :show-arrow="false"
          trigger="click"
          placement="bottom-end"
          popper-class="sp-rule-popover"
        >
          <div class="popover-content">
            <div class="title">
              SP规则设置
            </div>
            <div class="rule-content">
              <div class="item">
                <span class="label">战斗起始：</span>
                <div class="right">
                  <el-input-number
                    v-model="spSetting.total"
                    :controls="false"
                    controls-position="right"
                    :min="0"
                    style="width: 50px;"
                  />
                  <span>SP</span>
                </div>
              </div>
              <div class="item">
                <span class="label">本回合额外恢复：</span>
                <div class="right">
                  <el-input-number
                    v-model="extraAdd"
                    :controls="false"
                    controls-position="right"
                    :min="0"
                    style="width: 50px;"
                    @change="handleExtraAdd"
                  />
                  <span>SP</span>
                </div>
              </div>
              <div class="item">
                <span class="label">每回合恢复：</span>
                <div class="right">
                  <el-input-number
                    v-model="spSetting.roundAdd"
                    :controls="false"
                    controls-position="right"
                    :min="0"
                    style="width: 50px;"
                  />
                  <span>SP</span>
                </div>
              </div>
            </div>
          </div>
          <el-button slot="reference" type="primary" class="btn setting">
            <img
              src="@/assets/zs_imgs/battle/sp_setting_icon.png"
              class="btn-tip-icon"
              alt=""
              style="margin-right: 8px;"
            />
            <span>SP规则设置</span>
          </el-button>
        </el-popover>
        <el-popover
          width="208"
          :show-arrow="false"
          trigger="hover"
          placement="bottom-end"
          popper-class="sp-rule-popover"
        >
          <div class="popover-content">
            <div class="title">
              本回合恢复SP
            </div>
            <div class="content">
              填入本回合额外恢复的SP，例如黎维塔、伊柯利普斯、卢克雷齐亚等等技能的恢复SP值
            </div>
          </div>
          <el-button slot="reference" type="primary" class="btn tip" style="margin-left: 5px;">
            <img class="btn-tip-icon" src="@/assets/zs_imgs/battle/sp_tips_icon.png" alt="" />
          </el-button>
        </el-popover>
      </div>
    </div>
    <!-- <div v-if="mode === 'view'" :class="['view-sp', { 'error-sp': usedSp > lastSp }]">
      <span>SP {{ usedSp }} / {{ lastSp }}</span>
    </div> -->
  </div>
</template>
<script>
import draggable from "vuedraggable";
import { unionDict } from "@/views/wiki/battle/dict";

export default {
  components: {
    draggable
  },
  props: {
    mode: {
      type: String,
      default: "view"
    },
    // 模式
    battleType: {
      type: Number,
      default: 1
    },
    // 从0开始的回合数
    currentRound: {
      type: Number,
      default: 0
    },
    // 上回合要加的sp
    lastRoundExtraAdd: {
      type: Number,
      default: 0
    },
    unionSetting: {
      type: Object,
      default: () => ({})
    },
    parentWidth: {
      type: Number,
      default: 800
    },
    isShowEnemy: {
      type: Boolean,
      default: true
    }
  },
  watch: {},
  data() {
    return {
      unionDict,
      strengthArr: ["+1", "+2", "+3", "+4", "+5", "满破满潜力"],
      actionObj: {
        skills: "技能",
        damage: "攻击",
        repel: "击退",
        dead: "无法战斗"
      },
      ourSortData: [],
      ourPositionData: [],
      enemyData: [],
      // 要交换的目标元素下标
      destIndex: -1,
      // 要交换的起始元素下标
      srcIndex: -1,
      // 本回合恢复的sp
      extraAdd: 0,
      spSetting: {
        total: 0,
        roundAdd: 0
      }
    };
  },
  computed: {
    currentSkillUrl() {
      if (!this.unionSetting.skill) return "";
      return require(`@/assets/zs_imgs/battle/${this.unionSetting.skill}.webp`);
    },
    currentDesc() {
      const { skill, level } = this.unionSetting;
      if (!skill || !level) return "";
      return this.unionDict[`${skill}-${level}`];
    },
    // 本回合消耗的sp
    usedSp() {
      let sp = 0;
      this.ourPositionData.forEach(item => {
        if (item.sp) {
          sp += Number(item.sp);
        }
      });
      return sp;
    },
    // 还剩下的sp
    lastSp() {
      const beforeUsedSp = (this.currentRound || 0) * this.usedSp;
      const roundAddSp = (this.currentRound || 0) * 2 * (this.spSetting.roundAdd || 0);
      console.log("last", this.lastRoundExtraAdd);
      const res = this.spSetting.total - beforeUsedSp + this.lastRoundExtraAdd + roundAddSp;
      return res > 0 ? res : 0;
    },
    spCalcData() {
      // 1 为一般模式，2 为工会模式
      // 1 填充20个空数据的数组，2 填充30个空数据的数组
      let result = [];
      const len = this.battleType === 1 ? 20 : 30;
      for (let i = 0; i < len; i++) {
        result.push({
          index: i + 1
        });
      }
      if (this.usedSp > this.lastSp) {
        result = result.map((item, index) => {
          if (index < this.usedSp) {
            return {
              ...item,
              type: "error"
            };
          }
          return item;
        });
      } else if (this.usedSp === this.lastSp) {
        result = result.map((item, index) => {
          if (index < this.usedSp) {
            return {
              ...item,
              type: "used"
            };
          }
          return item;
        });
      } else {
        result = result.map((item, index) => {
          if (index < this.usedSp) {
            return {
              ...item,
              type: "used"
            };
          } else if (index < this.lastSp) {
            return {
              ...item,
              type: "round"
            };
          }
          return item;
        });
      }
      return result;
    },
    getCurrentIndex() {
      return item => {
        return this.ourSortData.findIndex(v => v.uniqueKey === item.uniqueKey) + 1;
      };
    },
    // 计算每个card的宽度
    calcCardStyle() {
      // 193 是左侧的宽度，32是padding， 50是箭头的宽度
      let gap = 0;
      let leftWidth = 193;
      let sideCount = 2;
      if (this.battleType === 1) {
        gap = 24;
      } else {
        gap = 32;
      }

      if (this.mode === "view" && this.isShowEnemy) {
        leftWidth = 0;
      }

      let width = this.parentWidth - leftWidth - 32 - 50;

      if (this.mode === "view" && !this.isShowEnemy) {
        sideCount = 1;
      }

      width = width / sideCount - gap;

      if (this.battleType === 1) {
        width = width / 4;
      } else {
        width = width / 5;
      }
      if (width > 87) {
        width = 87;
      }
      const height = width * 1.31;
      return {
        width: Math.floor(width),
        height: Math.floor(height)
      };
    },
    // 计算每个side的宽度
    calcSideStyle() {
      if (this.battleType === 1) {
        return {
          width: this.calcCardStyle.width * 4 + 24
        };
      } else {
        return {
          width: this.calcCardStyle.width * 5 + 32
        };
      }
    }
  },
  methods: {
    handleOurMove(e) {
      // console.log(e);
      this.destIndex = e.draggedContext.futureIndex;
      return false;
    },
    // 切换是否展示敌方阵容
    handleChangeShow(value) {
      this.$emit("change-show", value);
    },
    // 获取背景
    getItemBg(data) {
      if (data.attr === "火") {
        return "red";
      } else if (data.attr === "光") {
        return "yellow";
      } else if (data.attr === "水") {
        return "blue";
      } else if (data.attr === "暗") {
        return "purple";
      } else if (data.attr === "风") {
        return "green";
      }
      return "";
    },
    // 修改我方排序
    handleOurSortData() {
      this.$emit("handle-our-sort-data", this.ourSortData);
    },
    // 获取星级
    getStarUrl(type) {
      const number = parseInt(type);
      return require(`@/assets/zs_imgs/battle/star_${number}.png`);
    },
    // 获取强化图标
    getStrenthUrl(name) {
      if (name === "满破满潜力") {
        return require(`@/assets/zs_imgs/battle/strenth_full.webp`);
      }
      return require(`@/assets/zs_imgs/battle/strenth${name}.webp`);
    },
    // 获取角标图片
    getCornerUrl(item) {
      const star = parseInt(item.star);
      let potentialLength = item.currentPotential ? item.currentPotential.length : 0;
      if (potentialLength > 3) {
        potentialLength = 3;
      }
      if (star < 5) {
        if (potentialLength > 1) {
          potentialLength = 1;
        }
        return require(`@/assets/zs_imgs/battle/potential_${potentialLength}_star_34.png`);
      } else {
        return require(`@/assets/zs_imgs/battle/potential_${potentialLength}_star_5.png`);
      }
    },
    handleOurStart(e) {
      this.srcIndex = e.oldIndex;
    },
    handleOurEnd(e) {
      if (this.destIndex === this.srcIndex || this.destIndex === -1) {
        return;
      }
      // 开始拖拽的元素和目标元素交换位置
      const lastItem = this.ourPositionData[this.destIndex];
      const firstItem = this.ourPositionData[this.srcIndex];
      this.ourPositionData.splice(this.srcIndex, 1, lastItem);
      this.ourPositionData.splice(this.destIndex, 1, firstItem);

      this.destIndex = -1;
    },
    handleEnemy(index) {
      if (this.mode === "view") return;
      this.enemyData[index].type = this.enemyData[index].type === 0 ? 1 : 0;
    },
    // 设置数据
    initDatas(data, spSetting) {
      this.extraAdd = data.extraAdd || 0;
      this.ourSortData = data.ourSortData || [];
      this.ourPositionData = data.ourPositionData || [];
      this.enemyData = data.enemyData || [];
      if (spSetting) {
        this.spSetting = spSetting;
      }
    },
    // 点击新增角色
    handleAddRole() {
      this.$emit("handle-add-role");
    },
    // 点击查看角色详情
    handleRoleInfo(data) {
      if (data.type === 0) return;
      // if (this.mode === "view") {
      //   this.$emit("handle-role-info", data);
      // }
      this.$emit("handle-role-info", data);
    },
    // 点击角色
    handleEditRole(item, index) {
      if (this.mode === "view") return;
      this.$emit("handle-edit-role", index, item);
    },
    // 点击工会
    handleEditUnion() {
      if (this.mode === "view") return;
      this.$emit("handle-edit-union");
    },
    // 修改额外增加的sp
    handleExtraAdd(value) {
      this.$emit("extra-add", value || 0);
    }
  }
};
</script>
<style lang="less">
@import "./common.less";
.red-shadow {
  border: 1px solid #ff4747;
  box-shadow: 0px 0px 6px 4px rgba(255, 2, 2, 0.38);
  filter: blur(0px);
}
.yellow-shadow {
  box-shadow: 0px 0px 6px 4px rgba(255, 180, 0, 0.54);
  border: 1px solid #f0af14;
  filter: blur(0px);
}
.blue-shadow {
  box-shadow: 0px 0px 6px 4px rgba(0, 205, 255, 0.52);
  border: 1px solid #00cdff;
  filter: blur(0px);
}
.purple-shadow {
  box-shadow: 0px 0px 6px 4px rgba(243, 0, 255, 0.44);
  border: 1px solid #d224db;
  filter: blur(0px);
}
.green-shadow {
  box-shadow: 0px 0px 6px 4px rgba(61, 247, 42, 0.54);
  border: 1px solid #2ae417;
  filter: blur(0px);
}

.error-sp {
  color: #864242 !important;
}
.sp-rule-popover {
  padding: 0;
  border-radius: 8px;
  border: none;
  .popper__arrow {
    border-bottom-color: #ddd6ce !important;
    &:after {
      border-bottom-color: #ddd6ce !important;
    }
  }
  .popover-content {
    border-radius: 8px;
    overflow: hidden;
    .title {
      display: flex;
      align-items: center;
      height: 31px;
      padding-left: 10px;
      color: #5a4434;
      background-color: #ddd6ce;
    }
    .content {
      padding: 10px 12px;
      color: #666666;
      font-size: 12px;
      line-height: 17px;
      font-weight: 400;
    }
    .rule-content {
      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 56px;
        padding: 0 12px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
        color: #060606;
        font-size: 13px;
        .label {
          color: #333;
          font-size: 12px;
        }
        .right {
          display: flex;
          align-items: center;
          span {
            margin-left: 5px;
          }
        }
        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
.battle-main {
  width: 100%;
  // min-height: 481px;
  background: url("~@/assets/zs_imgs/battle/battle-bg.png") no-repeat;
  background-size: cover;
  .footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 17px;
    border-top: 1px solid rgba(0, 0, 0, 0.12);
    &.center-footer {
      justify-content: center;
      .sp-line {
        .sp-container {
          .star-item {
            img {
              width: 12px;
              height: 12px;
            }
          }
        }
      }
    }
    .sp-line {
      display: flex;
      align-items: center;
      .tip {
        margin-right: 8px;
        color: #060606;
        font-size: 13px;
        font-weight: 500;
      }
      .sp-container {
        display: flex;
        align-items: center;
        .star-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-right: 8px;
          &:last-child {
            margin-right: 0;
          }
          img {
            width: 10px;
            height: 10px;
            margin-bottom: 4px;
          }
          span {
            color: #666;
            font-size: 10px;
          }
        }
      }
    }
    .sp-setting {
      display: flex;
      align-items: center;
      margin-left: 10px;
      .btn {
        height: 28px;
        padding: 0;
        color: #fff;
        background-color: #967a5f;
        border-color: transparent;
        span {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        &.tip {
          width: 28px;
        }
        &.setting {
          width: 104px;
        }
        .btn-tip-icon {
          width: 18px;
          height: 18px;
        }
      }
    }
  }
  .view-sp {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding-bottom: 16px;
    color: #060606;
    line-height: 20px;
    font-size: 14px;
    font-weight: 600;
  }
}
.battle-content {
  display: flex;
  justify-content: center;
  // width: 100%;
  &.union {
    .right {
      .container {
        .draggle-box {
          padding-bottom: 8px;
          .side {
            .drag-list {
              gap: 8px;
            }
          }
        }
      }
    }
  }
  .left {
    display: flex;
    flex-direction: column;
    flex: 0 0 auto;
    width: 193px;
    padding-top: 16px;
    box-sizing: border-box;
    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 0 0 auto;
      height: 24px;
      margin-bottom: 8px;
      text-align: center;
      font-size: 12px;
      color: #fff;
      background-color: #aea096;
    }
    .inner-content {
      flex: 1;
      overflow: auto;
      .add-role {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #333;
        font-size: 15px;
        cursor: pointer;
      }
      .drag-list {
        display: flex;
        flex-direction: column;
        .item {
          display: flex;
          width: 100%;
          height: 60px;
          padding: 0 6px;
          margin-bottom: 8px;
          box-sizing: border-box;
          background: rgba(90, 74, 66, 0.2);
          border: 1px solid rgba(132, 120, 113, 0.43);
          cursor: pointer;
          &:last-child {
            margin-bottom: 0;
          }
          .index {
            position: relative;
            flex: 0 0 auto;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 20px;
            height: 20px;
            margin-right: 5px;
            color: #fff;
            font-size: 14px;
            line-height: 18px;
            background: url("~@/assets/zs_imgs/battle/index_tag_bg.png") no-repeat;
            background-size: 100% 100%;
            // background-color: #424a56;
            // &::after {
            //   position: absolute;
            //   bottom: -6px;
            //   left: 0;
            //   content: "";
            //   width: 0;
            //   height: 0;
            //   border-top: 6px solid #424a56;
            //   border-left: 9px solid transparent;
            //   border-right: 9px solid transparent;
            // }
          }
          .icon {
            flex: 0 0 auto;
            width: 56px;
            height: 100%;
            margin-right: 6px;
            background-color: rgba(90, 74, 66, 0.2);
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .infos {
            display: flex;
            flex-direction: column;
            justify-content: center;
            flex: 1;
            overflow: hidden;
            // p {
            //   overflow: hidden;
            //   text-overflow: ellipsis;
            //   white-space: nowrap;
            // }
            .name {
              color: #372e25;
              font-size: 13px;
              line-height: 18px;
            }
            .des {
              color: #666666;
              font-size: 12px;
              line-height: 17px;
            }
          }
          .pic {
            display: flex;
            align-items: center;
            flex: 0 0 auto;
            // margin-left: 6px;
            img {
              width: 25px;
              height: 25px;
              object-fit: cover;
            }
          }
        }
      }
    }
  }
  .right {
    .container {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;

      .draggle-box {
        display: flex;
        justify-content: space-between;
        padding: 16px;
        &.no-padding {
          padding-right: 0;
        }
        .arrow {
          display: flex;
          align-items: center;
          padding-top: 44px;
          margin: 0 10px;
          &.no-padding {
            padding: 0;
          }
          &.no-margin {
            margin-right: 0;
          }
          img {
            width: 30px;
            height: 30px;
          }
        }
        .side {
          &.left-side {
            .union-line {
              display: flex;
              width: 100%;
              height: 50px;
              margin-top: 12px;
              cursor: pointer;
              box-sizing: border-box;
              border: 1px solid #979797;
              background-color: #d1c9c3;
              .icon {
                flex: 0 0 auto;
                width: 96px;
                height: 100%;
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
              }
              .dead-content {
                display: flex;
                justify-content: center;
                align-items: center;
                flex: 1;
                height: 100%;
                box-sizing: border-box;
                color: #333333;
                font-size: 14px;
                font-weight: 600;
              }
              .action-content {
                flex: 1;
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 100%;
                padding: 7px 10px;
                box-sizing: border-box;
                overflow: hidden;
                .infos {
                  flex: 1;
                  display: flex;
                  flex-direction: column;
                  overflow: hidden;
                  .name {
                    margin-bottom: 2px;
                    color: #333333;
                    font-size: 14px;
                    font-weight: 600;
                    line-height: 20px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                  .des {
                    width: 100%;
                    color: rgba(51, 51, 51, 0.7);
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 18px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                }
                .skill-img {
                  flex: 0 0 auto;
                  width: 40px;
                  height: 40px;
                  margin-left: 20px;
                  overflow: hidden;
                  img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                  }
                }
              }
            }
          }
          .title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;
            color: #333;
            font-size: 14px;
            line-height: 20px;
            padding-bottom: 8px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.45);
            .options {
            }
          }
          .drag-list {
            display: flex;
            flex-wrap: wrap;
            gap: 10px 8px;
            .drag-bg {
              position: relative;
              border: 1px solid #847871;
              box-sizing: border-box;
              background-color: rgba(90, 74, 66, 0.2);
              // 禁止选择
              user-select: none;
              transition: all ease;
              .drag-item {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                padding: 5px;
                box-sizing: border-box;
                background: url("~@/assets/zs_imgs/battle/battle-normal.png") no-repeat;
                background-size: 100% 100%;
                cursor: pointer;
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
                .item-bg {
                  position: absolute;
                  left: 0;
                  top: 0;
                  padding: 5px;
                  width: 100%;
                  height: 100%;
                  box-sizing: border-box;
                }
                .item-infos {
                  position: absolute;
                  left: 0;
                  top: 0;
                  width: 100%;
                  height: 100%;
                  padding: 5px 6px;
                  box-sizing: border-box;
                  .role-img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                  }
                  .index {
                    position: absolute;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    left: 5px;
                    top: 5px;
                    width: 20px;
                    height: 20px;
                    line-height: 16px;
                    color: #fff;
                    font-size: 12px;
                    font-weight: 500;
                    background: url("~@/assets/zs_imgs/battle/index_tag_bg.png") no-repeat;
                    background-size: 100% 100%;
                  }
                  .strenth-icon {
                    position: absolute;
                    right: 4px;
                    top: 4px;
                    width: 29px;
                    height: 23px;
                    img {
                      width: 100%;
                      height: 100%;
                      object-fit: cover;
                    }
                  }
                  .corner-icon {
                    display: flex;
                    position: absolute;
                    top: 35px;
                    right: 4px;
                    width: 20px;
                    height: 20px;
                    img {
                      width: 100%;
                      height: 100%;
                      object-fit: cover;
                    }
                  }
                  .attr-icon {
                    position: absolute;
                    bottom: 32px;
                    right: 6px;
                    width: 15px;
                    height: 15px;
                    img {
                      width: 100%;
                      height: 100%;
                      object-fit: cover;
                    }
                  }
                  .star-icon {
                    display: flex;
                    align-items: center;
                    position: absolute;
                    bottom: 34px;
                    left: 6px;
                    height: 10px;
                    img {
                      height: 100%;
                      width: auto;
                      object-fit: cover;
                    }
                  }
                  .bottom-info {
                    position: absolute;
                    bottom: 5px;
                    left: 5px;
                    display: flex;
                    align-items: center;
                    width: calc(100% - 10px);
                    height: 25px;
                    padding: 3px 3px;
                    box-sizing: border-box;
                    background-color: rgba(34, 24, 21, 0.69);
                    img {
                      flex: 0 0 auto;
                      width: 18px;
                      height: 18px;
                    }
                    .label {
                      display: flex;
                      // justify-content: center;
                      flex: 1;
                      color: #fff;
                      font-size: 10px;
                      font-weight: 500;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    }
                  }
                }
              }
              .enemy-item {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                box-sizing: border-box;
                cursor: pointer;
                &.has-enemy {
                  background: url("~@/assets/zs_imgs/battle/monster_bg.png") no-repeat;
                  background-size: 100% 100%;
                }
              }
              &.chosen-item {
                .drag-item {
                  background: url("~@/assets/zs_imgs/battle/battle-choosed.png") no-repeat !important;
                  background-size: 100% 100% !important;
                }
              }
              &.choosed-item {
                .drag-item {
                  background: url("~@/assets/zs_imgs/battle/battle-choosed.png") no-repeat !important;
                  background-size: 100% 100% !important;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
